/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AppContextsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
        ): string => {
            let clientRequestUrl = '/api/v1/app-contexts';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getMaintenancePageToggle: (
        ): string => {
            let clientRequestUrl = '/api/v1/app-contexts/maintenance-configuration';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get application context
     * @return OK
     */
    get(): Promise<AppContext> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<AppContext>(_response, false, []);
        });
    }

    /**
     * Get maintenance page toggle
     * @return OK
     */
    getMaintenancePageToggle(): Promise<MaintenanceConfigurationResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getMaintenancePageToggle(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<MaintenanceConfigurationResponse>(_response, false, ['maintenanceEndDate']);
        });
    }
}

export class ContractsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getContractsStatuses: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/statuses';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAmountToBeRegularized: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/amount-to-be-regularized';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractIds: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/ids';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        search: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/do-get-search';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractInformation: (
			siren: string,
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/id/{id}/_information';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractAssets: (
			siren: string,
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/id/{id}/assets';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractBilling: (
			siren: string,
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/id/{id}/_billing';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getExport: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/export';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getFinancialTypeCount: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/financial-type-count';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get contracts Information
     * @return OK
     */
    getContractsStatuses(siren: string): Promise<ContractsStatuses> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractsStatuses(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ContractsStatuses>(_response, false, []);
        });
    }

    /**
     * Get amount to be regularized
     * @return OK
     */
    getAmountToBeRegularized(siren: string): Promise<Amount> {
        const clientRequestUrl = this.baseUrl + this.routes.getAmountToBeRegularized(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<Amount>(_response, false, []);
        });
    }

    /**
     * Get all contracts ids
     * @return OK
     */
    getContractIds(siren: string): Promise<ContractsIds> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractIds(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ContractsIds>(_response, false, []);
        });
    }

    /**
     * Get user contracts
     * @param body (optional) 
     * @return OK
     */
    search(siren: string, body?: SearchContractRequest | undefined): Promise<ContractPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.search(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ContractPaginationResult>(_response, false, []);
        });
    }

    /**
     * Get contract information
     * @return OK
     */
    getContractInformation(siren: string, id: string): Promise<ContractInformation> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractInformation(
            siren,
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ContractInformation>(_response, false, ['rentalStartDate', 'nextDueDate', 'rentalEndDate']);
        });
    }

    /**
     * Get contract assets
     * @return OK
     */
    getContractAssets(siren: string, id: string): Promise<ContractAssets> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractAssets(
            siren,
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ContractAssets>(_response, false, []);
        });
    }

    /**
     * Get contract billing
     * @return OK
     */
    getContractBilling(siren: string, id: string): Promise<ContractBilling> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractBilling(
            siren,
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ContractBilling>(_response, false, []);
        });
    }

    /**
     * Download contracts details
     * @return OK
     */
    getExport(siren: string): Promise<FileResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getExport(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<FileResponse>(_response, true, ['start', 'end']);
        });
    }

    /**
     * Get contract types count by financial type
     * @return OK
     */
    getFinancialTypeCount(siren: string): Promise<FinancialTypeCountResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getFinancialTypeCount(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<FinancialTypeCountResponse>(_response, false, []);
        });
    }
}

export class CustomerRequestsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getCustomerRequests: (
			siren: string,
			contractId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}?';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (contractId === null) {
                throw new Error('The parameter "contractId" cannot be null.');
            } else if (contractId !== undefined) {
                clientRequestUrl += 'contractId=' + encodeURIComponent('' + contractId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getCustomerRequestsCount: (
			siren: string,
			contractId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/count?';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (contractId === null) {
                throw new Error('The parameter "contractId" cannot be null.');
            } else if (contractId !== undefined) {
                clientRequestUrl += 'contractId=' + encodeURIComponent('' + contractId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getCustomerRequestsStatuses: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/statuses';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitDocumentContractRelatedRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/document/contract-related';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitDocumentAccountExtractRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/document/account-extract';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitDocumentEquipmentRelatedRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/document/equipment-related';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitDocumentCopyOfContractualElementRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/document/copy-of-contractual-element';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractContractTransferRequest: (
			siren: string,
			contractsIds?: string[] | undefined,
			hasDocument?: boolean | undefined,
			effectiveDate?: Date | undefined,
			buyback?: TypeOfBuyback | null | undefined,
			toReturnMaterials?: string[] | undefined,
			reason?: ContractTransferReason | undefined,
			commentary?: string | null | undefined,
			buyerContact_lastName?: string | undefined,
			buyerContact_firstName?: string | undefined,
			buyerContact_email?: string | undefined,
			buyerContact_phoneNumber?: string | undefined,
			buyerContact_jobTitle?: string | undefined,
			buyerAddress_sirenCode?: string | undefined,
			buyerAddress_businessName?: string | undefined,
			buyerAddress_streetNumber?: string | undefined,
			buyerAddress_streetName?: string | undefined,
			buyerAddress_additionalAddress?: string | null | undefined,
			buyerAddress_zipCode?: number | null | undefined,
			buyerAddress_city?: string | undefined,
			kbisFile?: FileParameter | undefined,
			businessTakeoverFile?: FileParameter | null | undefined,
			optionalCommentary?: string | null | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/contract-transfer';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractDenialOfContractRenewalRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/denial-of-contract-renewal';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitExerciseOfPurchaseOptionRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/exercise-of-purchase-option';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractReturnOfEquipmentRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/return-of-equipment';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractEarlyRedemptionRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/early-buyback';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractTerminationOfContractRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/termination-of-contract';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitBillingBillingAddressRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/billing/billing-address';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitBillingBankDetailsRequest: (
			siren: string,
			contractsIds?: string[] | undefined,
			hasDocument?: boolean | undefined,
			optionalCommentary?: string | undefined,
			bankDetails_accountHolder?: string | undefined,
			bankDetails_iban?: string | undefined,
			bankDetails_bic?: string | undefined,
			termsAcceptedProfessionalAccount?: boolean | undefined,
			termsAcceptedDebitAuthorization?: boolean | undefined,
			termsAcceptedCompanyIsTheOnlyTenant?: boolean | undefined,
			ribFile?: FileParameter | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/billing/bank-details';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitBillingOrderNumberRequest: (
			siren: string,
			contractsIds?: string[] | undefined,
			hasDocument?: boolean | undefined,
			optionalCommentary?: string | undefined,
			orderNumber?: string | undefined,
			validityPeriod?: ValidityPeriod | null | undefined,
			orderFormFile?: FileParameter | null | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/billing/order-number';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitChangeBankDetailsRequest: (
			siren: string,
			contractsIds?: string[] | undefined,
			hasDocument?: boolean | undefined,
			optionalCommentary?: string | undefined,
			bankDetails_accountHolder?: string | undefined,
			bankDetails_iban?: string | undefined,
			bankDetails_bic?: string | undefined,
			termsAcceptedProfessionalAccount?: boolean | undefined,
			termsAcceptedDebitAuthorization?: boolean | undefined,
			termsAcceptedCompanyIsTheOnlyTenant?: boolean | undefined,
			ribFile?: FileParameter | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/change/bank-details';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitChangeContractTransferRequest: (
			siren: string,
			contractsIds?: string[] | undefined,
			hasDocument?: boolean | undefined,
			effectiveDate?: Date | undefined,
			buyback?: TypeOfBuyback | null | undefined,
			toReturnMaterials?: string[] | undefined,
			reason?: ContractTransferReason | undefined,
			commentary?: string | null | undefined,
			buyerContact_lastName?: string | undefined,
			buyerContact_firstName?: string | undefined,
			buyerContact_email?: string | undefined,
			buyerContact_phoneNumber?: string | undefined,
			buyerContact_jobTitle?: string | undefined,
			buyerAddress_sirenCode?: string | undefined,
			buyerAddress_businessName?: string | undefined,
			buyerAddress_streetNumber?: string | undefined,
			buyerAddress_streetName?: string | undefined,
			buyerAddress_additionalAddress?: string | null | undefined,
			buyerAddress_zipCode?: number | null | undefined,
			buyerAddress_city?: string | undefined,
			kbisFile?: FileParameter | undefined,
			businessTakeoverFile?: FileParameter | null | undefined,
			optionalCommentary?: string | null | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/change/contract-transfer';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitChangeHeadOfficeAddressRequest: (
			siren: string,
			contractsIds?: string[] | undefined,
			hasDocument?: boolean | undefined,
			optionalCommentary?: string | undefined,
			headOfficeAddress_streetNumber?: string | undefined,
			headOfficeAddress_streetName?: string | undefined,
			headOfficeAddress_additionalAddress?: string | null | undefined,
			headOfficeAddress_zipCode?: number | null | undefined,
			headOfficeAddress_city?: string | undefined,
			kbisFile?: FileParameter | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/change/head-office-address';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitChangeFinancialConditionRequest: (
			siren: string,
			contractsIds?: string[] | null | undefined,
			hasDocument?: boolean | undefined,
			optionalCommentary?: string | null | undefined,
			financialConditionType?: FinancialConditionType | null | undefined,
			effectiveDate?: Date | null | undefined,
			financialConditionPeriodicity?: FinancialConditionPeriodicity | null | undefined,
			reason?: string | null | undefined,
			lastFinancialStatementFile?: FileParameter | null | undefined,
			lastVatStatementsFile?: FileParameter | null | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/change/financial-condition';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        uploadFile: (
			siren: string,
			type?: UploadFileType | undefined,
			contractNb?: string | undefined,
			fileToUpload?: FileParameter | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/upload-files?';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (type === null) {
                throw new Error('The parameter "type" cannot be null.');
            } else if (type !== undefined) {
                clientRequestUrl += 'type=' + encodeURIComponent('' + type) + '&';
            }
            if (contractNb === null) {
                throw new Error('The parameter "contractNb" cannot be null.');
            } else if (contractNb !== undefined) {
                clientRequestUrl += 'contractNb=' + encodeURIComponent('' + contractNb) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get All Customer Requests
     * @param contractId (optional) 
     * @return OK
     */
    getCustomerRequests(siren: string, contractId?: string | undefined): Promise<CustomerRequestList> {
        const clientRequestUrl = this.baseUrl + this.routes.getCustomerRequests(
            siren,
            contractId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<CustomerRequestList>(_response, false, ['date', 'latestUpdate']);
        });
    }

    /**
     * Get Customer Requests Count
     * @param contractId (optional) 
     * @return OK
     */
    getCustomerRequestsCount(siren: string, contractId?: string | undefined): Promise<CustomerRequestsCount> {
        const clientRequestUrl = this.baseUrl + this.routes.getCustomerRequestsCount(
            siren,
            contractId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<CustomerRequestsCount>(_response, false, []);
        });
    }

    /**
     * Get Customer Requests Information
     * @return OK
     */
    getCustomerRequestsStatuses(siren: string): Promise<CustomerRequestStatuses> {
        const clientRequestUrl = this.baseUrl + this.routes.getCustomerRequestsStatuses(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<CustomerRequestStatuses>(_response, false, []);
        });
    }

    /**
     * Submit Document Contract Related Request
     * @param body (optional) 
     * @return No Content
     */
    submitDocumentContractRelatedRequest(siren: string, body?: ContractRelatedRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitDocumentContractRelatedRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Document Account statement request
     * @param body (optional) 
     * @return No Content
     */
    submitDocumentAccountExtractRequest(siren: string, body?: AccountExtractRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitDocumentAccountExtractRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Document Equipment Related Request
     * @param body (optional) 
     * @return No Content
     */
    submitDocumentEquipmentRelatedRequest(siren: string, body?: EquipmentRelatedRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitDocumentEquipmentRelatedRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Document Copy Of Contractual Element Request
     * @param body (optional) 
     * @return No Content
     */
    submitDocumentCopyOfContractualElementRequest(siren: string, body?: CopyOfContractualElementRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitDocumentCopyOfContractualElementRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit EndOfContract Contract Transfer Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param effectiveDate (optional) 
     * @param buyback (optional) 
     * @param toReturnMaterials (optional) 
     * @param reason (optional) 
     * @param commentary (optional) 
     * @param buyerContact_lastName (optional) 
     * @param buyerContact_firstName (optional) 
     * @param buyerContact_email (optional) 
     * @param buyerContact_phoneNumber (optional) 
     * @param buyerContact_jobTitle (optional) 
     * @param buyerAddress_sirenCode (optional) 
     * @param buyerAddress_businessName (optional) 
     * @param buyerAddress_streetNumber (optional) 
     * @param buyerAddress_streetName (optional) 
     * @param buyerAddress_additionalAddress (optional) 
     * @param buyerAddress_zipCode (optional) 
     * @param buyerAddress_city (optional) 
     * @param kbisFile (optional) 
     * @param businessTakeoverFile (optional) 
     * @param optionalCommentary (optional) 
     * @return No Content
     */
    submitEndOfContractContractTransferRequest(siren: string, contractsIds?: string[] | undefined, hasDocument?: boolean | undefined, effectiveDate?: Date | undefined, buyback?: TypeOfBuyback | null | undefined, toReturnMaterials?: string[] | undefined, reason?: ContractTransferReason | undefined, commentary?: string | null | undefined, buyerContact_lastName?: string | undefined, buyerContact_firstName?: string | undefined, buyerContact_email?: string | undefined, buyerContact_phoneNumber?: string | undefined, buyerContact_jobTitle?: string | undefined, buyerAddress_sirenCode?: string | undefined, buyerAddress_businessName?: string | undefined, buyerAddress_streetNumber?: string | undefined, buyerAddress_streetName?: string | undefined, buyerAddress_additionalAddress?: string | null | undefined, buyerAddress_zipCode?: number | null | undefined, buyerAddress_city?: string | undefined, kbisFile?: FileParameter | undefined, businessTakeoverFile?: FileParameter | null | undefined, optionalCommentary?: string | null | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractContractTransferRequest(
            siren,
            contractsIds,
            hasDocument,
            effectiveDate,
            buyback,
            toReturnMaterials,
            reason,
            commentary,
            buyerContact_lastName,
            buyerContact_firstName,
            buyerContact_email,
            buyerContact_phoneNumber,
            buyerContact_jobTitle,
            buyerAddress_sirenCode,
            buyerAddress_businessName,
            buyerAddress_streetNumber,
            buyerAddress_streetName,
            buyerAddress_additionalAddress,
            buyerAddress_zipCode,
            buyerAddress_city,
            kbisFile,
            businessTakeoverFile,
            optionalCommentary,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error('The parameter "contractsIds" cannot be null.');
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append("contractsIds[" + index_ + "]",item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error('The parameter "hasDocument" cannot be null.');
        } else {
            content.append("hasDocument", hasDocument.toString());
        }
        if (effectiveDate === null || effectiveDate === undefined) {
            throw new Error('The parameter "effectiveDate" cannot be null.');
        } else {
            content.append("effectiveDate", effectiveDate.toJSON());
        }
        if (buyback !== null && buyback !== undefined) {
            content.append("buyback", buyback.toString());
        }
        if (toReturnMaterials === null || toReturnMaterials === undefined) {
            throw new Error('The parameter "toReturnMaterials" cannot be null.');
        } else {
            toReturnMaterials.forEach((item_, index_) => {
                    content.append("toReturnMaterials[" + index_ + "]",item_.toString());
                });
        }
        if (reason === null || reason === undefined) {
            throw new Error('The parameter "reason" cannot be null.');
        } else {
            content.append("reason", reason.toString());
        }
        if (commentary !== null && commentary !== undefined) {
            content.append("commentary", commentary.toString());
        }
        if (buyerContact_lastName === null || buyerContact_lastName === undefined) {
            throw new Error('The parameter "buyerContact_lastName" cannot be null.');
        } else {
            content.append("buyerContact.lastName", buyerContact_lastName.toString());
        }
        if (buyerContact_firstName === null || buyerContact_firstName === undefined) {
            throw new Error('The parameter "buyerContact_firstName" cannot be null.');
        } else {
            content.append("buyerContact.firstName", buyerContact_firstName.toString());
        }
        if (buyerContact_email === null || buyerContact_email === undefined) {
            throw new Error('The parameter "buyerContact_email" cannot be null.');
        } else {
            content.append("buyerContact.email", buyerContact_email.toString());
        }
        if (buyerContact_phoneNumber === null || buyerContact_phoneNumber === undefined) {
            throw new Error('The parameter "buyerContact_phoneNumber" cannot be null.');
        } else {
            content.append("buyerContact.phoneNumber", buyerContact_phoneNumber.toString());
        }
        if (buyerContact_jobTitle === null || buyerContact_jobTitle === undefined) {
            throw new Error('The parameter "buyerContact_jobTitle" cannot be null.');
        } else {
            content.append("buyerContact.jobTitle", buyerContact_jobTitle.toString());
        }
        if (buyerAddress_sirenCode === null || buyerAddress_sirenCode === undefined) {
            throw new Error('The parameter "buyerAddress_sirenCode" cannot be null.');
        } else {
            content.append("buyerAddress.sirenCode", buyerAddress_sirenCode.toString());
        }
        if (buyerAddress_businessName === null || buyerAddress_businessName === undefined) {
            throw new Error('The parameter "buyerAddress_businessName" cannot be null.');
        } else {
            content.append("buyerAddress.businessName", buyerAddress_businessName.toString());
        }
        if (buyerAddress_streetNumber === null || buyerAddress_streetNumber === undefined) {
            throw new Error('The parameter "buyerAddress_streetNumber" cannot be null.');
        } else {
            content.append("buyerAddress.streetNumber", buyerAddress_streetNumber.toString());
        }
        if (buyerAddress_streetName === null || buyerAddress_streetName === undefined) {
            throw new Error('The parameter "buyerAddress_streetName" cannot be null.');
        } else {
            content.append("buyerAddress.streetName", buyerAddress_streetName.toString());
        }
        if (buyerAddress_additionalAddress !== null && buyerAddress_additionalAddress !== undefined) {
            content.append("buyerAddress.additionalAddress", buyerAddress_additionalAddress.toString());
        }
        if (buyerAddress_zipCode !== null && buyerAddress_zipCode !== undefined) {
            content.append("buyerAddress.zipCode", buyerAddress_zipCode.toString());
        }
        if (buyerAddress_city === null || buyerAddress_city === undefined) {
            throw new Error('The parameter "buyerAddress_city" cannot be null.');
        } else {
            content.append("buyerAddress.city", buyerAddress_city.toString());
        }
        if (kbisFile === null || kbisFile === undefined) {
            throw new Error('The parameter "kbisFile" cannot be null.');
        } else {
            content.append("kbisFile", kbisFile.data, kbisFile.fileName ? kbisFile.fileName : "kbisFile");
        }
        if (businessTakeoverFile !== null && businessTakeoverFile !== undefined) {
            content.append("businessTakeoverFile", businessTakeoverFile.data, businessTakeoverFile.fileName ? businessTakeoverFile.fileName : "businessTakeoverFile");
        }
        if (optionalCommentary !== null && optionalCommentary !== undefined) {
            content.append("optionalCommentary", optionalCommentary.toString());
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit EndOfContract denial of contract renewal Request
     * @param body (optional) 
     * @return No Content
     */
    submitEndOfContractDenialOfContractRenewalRequest(siren: string, body?: DenialOfContractRenewalRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractDenialOfContractRenewalRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit EndOfContract exercise of purchase option Request
     * @param body (optional) 
     * @return No Content
     */
    submitExerciseOfPurchaseOptionRequest(siren: string, body?: ExerciseOfPurchaseOptionRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitExerciseOfPurchaseOptionRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit EndOfContract Return Of Equipment Request
     * @param body (optional) 
     * @return No Content
     */
    submitEndOfContractReturnOfEquipmentRequest(siren: string, body?: ReturnOfEquipmentRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractReturnOfEquipmentRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit EndOfContract Early buyback Request
     * @param body (optional) 
     * @return No Content
     */
    submitEndOfContractEarlyRedemptionRequest(siren: string, body?: EarlyRedemptionRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractEarlyRedemptionRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit EndOfContract Termination Of Contract
     * @param body (optional) 
     * @return No Content
     */
    submitEndOfContractTerminationOfContractRequest(siren: string, body?: TerminationOfContractRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractTerminationOfContractRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Billing Billing address Request
     * @param body (optional) 
     * @return No Content
     */
    submitBillingBillingAddressRequest(siren: string, body?: BillingAddressRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitBillingBillingAddressRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Billing Bank details Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param bankDetails_accountHolder (optional) 
     * @param bankDetails_iban (optional) 
     * @param bankDetails_bic (optional) 
     * @param termsAcceptedProfessionalAccount (optional) Je certifie que ce compte est un compte professionnel et que notre société en est le titulaire.
     * @param termsAcceptedDebitAuthorization (optional) Je certifie que notre société autorise le prélèvement des loyers de son(ses) contrat(s) sur les nouvelles coordonnées bancaires communiquées.
     * @param termsAcceptedCompanyIsTheOnlyTenant (optional) Je confirme que notre société reste l’utilisatrice des matériels loués (pas de changement de locataire à déclarer).
     * @param ribFile (optional) 
     * @return No Content
     */
    submitBillingBankDetailsRequest(siren: string, contractsIds?: string[] | undefined, hasDocument?: boolean | undefined, optionalCommentary?: string | undefined, bankDetails_accountHolder?: string | undefined, bankDetails_iban?: string | undefined, bankDetails_bic?: string | undefined, termsAcceptedProfessionalAccount?: boolean | undefined, termsAcceptedDebitAuthorization?: boolean | undefined, termsAcceptedCompanyIsTheOnlyTenant?: boolean | undefined, ribFile?: FileParameter | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitBillingBankDetailsRequest(
            siren,
            contractsIds,
            hasDocument,
            optionalCommentary,
            bankDetails_accountHolder,
            bankDetails_iban,
            bankDetails_bic,
            termsAcceptedProfessionalAccount,
            termsAcceptedDebitAuthorization,
            termsAcceptedCompanyIsTheOnlyTenant,
            ribFile,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error('The parameter "contractsIds" cannot be null.');
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append("contractsIds[" + index_ + "]",item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error('The parameter "hasDocument" cannot be null.');
        } else {
            content.append("hasDocument", hasDocument.toString());
        }
        if (optionalCommentary === null || optionalCommentary === undefined) {
            throw new Error('The parameter "optionalCommentary" cannot be null.');
        } else {
            content.append("optionalCommentary", optionalCommentary.toString());
        }
        if (bankDetails_accountHolder === null || bankDetails_accountHolder === undefined) {
            throw new Error('The parameter "bankDetails_accountHolder" cannot be null.');
        } else {
            content.append("bankDetails.accountHolder", bankDetails_accountHolder.toString());
        }
        if (bankDetails_iban === null || bankDetails_iban === undefined) {
            throw new Error('The parameter "bankDetails_iban" cannot be null.');
        } else {
            content.append("bankDetails.iban", bankDetails_iban.toString());
        }
        if (bankDetails_bic === null || bankDetails_bic === undefined) {
            throw new Error('The parameter "bankDetails_bic" cannot be null.');
        } else {
            content.append("bankDetails.bic", bankDetails_bic.toString());
        }
        if (termsAcceptedProfessionalAccount === null || termsAcceptedProfessionalAccount === undefined) {
            throw new Error('The parameter "termsAcceptedProfessionalAccount" cannot be null.');
        } else {
            content.append("termsAcceptedProfessionalAccount", termsAcceptedProfessionalAccount.toString());
        }
        if (termsAcceptedDebitAuthorization === null || termsAcceptedDebitAuthorization === undefined) {
            throw new Error('The parameter "termsAcceptedDebitAuthorization" cannot be null.');
        } else {
            content.append("termsAcceptedDebitAuthorization", termsAcceptedDebitAuthorization.toString());
        }
        if (termsAcceptedCompanyIsTheOnlyTenant === null || termsAcceptedCompanyIsTheOnlyTenant === undefined) {
            throw new Error('The parameter "termsAcceptedCompanyIsTheOnlyTenant" cannot be null.');
        } else {
            content.append("termsAcceptedCompanyIsTheOnlyTenant", termsAcceptedCompanyIsTheOnlyTenant.toString());
        }
        if (ribFile === null || ribFile === undefined) {
            throw new Error('The parameter "ribFile" cannot be null.');
        } else {
            content.append("ribFile", ribFile.data, ribFile.fileName ? ribFile.fileName : "ribFile");
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Billing Order number Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param orderNumber (optional) 
     * @param validityPeriod (optional) 
     * @param orderFormFile (optional) 
     * @return No Content
     */
    submitBillingOrderNumberRequest(siren: string, contractsIds?: string[] | undefined, hasDocument?: boolean | undefined, optionalCommentary?: string | undefined, orderNumber?: string | undefined, validityPeriod?: ValidityPeriod | null | undefined, orderFormFile?: FileParameter | null | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitBillingOrderNumberRequest(
            siren,
            contractsIds,
            hasDocument,
            optionalCommentary,
            orderNumber,
            validityPeriod,
            orderFormFile,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error('The parameter "contractsIds" cannot be null.');
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append("contractsIds[" + index_ + "]",item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error('The parameter "hasDocument" cannot be null.');
        } else {
            content.append("hasDocument", hasDocument.toString());
        }
        if (optionalCommentary === null || optionalCommentary === undefined) {
            throw new Error('The parameter "optionalCommentary" cannot be null.');
        } else {
            content.append("optionalCommentary", optionalCommentary.toString());
        }
        if (orderNumber === null || orderNumber === undefined) {
            throw new Error('The parameter "orderNumber" cannot be null.');
        } else {
            content.append("orderNumber", orderNumber.toString());
        }
        if (validityPeriod !== null && validityPeriod !== undefined) {
            content.append("validityPeriod", validityPeriod.toString());
        }
        if (orderFormFile !== null && orderFormFile !== undefined) {
            content.append("orderFormFile", orderFormFile.data, orderFormFile.fileName ? orderFormFile.fileName : "orderFormFile");
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Change Bank details Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param bankDetails_accountHolder (optional) 
     * @param bankDetails_iban (optional) 
     * @param bankDetails_bic (optional) 
     * @param termsAcceptedProfessionalAccount (optional) Je certifie que ce compte est un compte professionnel et que notre société en est le titulaire.
     * @param termsAcceptedDebitAuthorization (optional) Je certifie que notre société autorise le prélèvement des loyers de son(ses) contrat(s) sur les nouvelles coordonnées bancaires communiquées.
     * @param termsAcceptedCompanyIsTheOnlyTenant (optional) Je confirme que notre société reste l’utilisatrice des matériels loués (pas de changement de locataire à déclarer).
     * @param ribFile (optional) 
     * @return No Content
     */
    submitChangeBankDetailsRequest(siren: string, contractsIds?: string[] | undefined, hasDocument?: boolean | undefined, optionalCommentary?: string | undefined, bankDetails_accountHolder?: string | undefined, bankDetails_iban?: string | undefined, bankDetails_bic?: string | undefined, termsAcceptedProfessionalAccount?: boolean | undefined, termsAcceptedDebitAuthorization?: boolean | undefined, termsAcceptedCompanyIsTheOnlyTenant?: boolean | undefined, ribFile?: FileParameter | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitChangeBankDetailsRequest(
            siren,
            contractsIds,
            hasDocument,
            optionalCommentary,
            bankDetails_accountHolder,
            bankDetails_iban,
            bankDetails_bic,
            termsAcceptedProfessionalAccount,
            termsAcceptedDebitAuthorization,
            termsAcceptedCompanyIsTheOnlyTenant,
            ribFile,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error('The parameter "contractsIds" cannot be null.');
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append("contractsIds[" + index_ + "]",item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error('The parameter "hasDocument" cannot be null.');
        } else {
            content.append("hasDocument", hasDocument.toString());
        }
        if (optionalCommentary === null || optionalCommentary === undefined) {
            throw new Error('The parameter "optionalCommentary" cannot be null.');
        } else {
            content.append("optionalCommentary", optionalCommentary.toString());
        }
        if (bankDetails_accountHolder === null || bankDetails_accountHolder === undefined) {
            throw new Error('The parameter "bankDetails_accountHolder" cannot be null.');
        } else {
            content.append("bankDetails.accountHolder", bankDetails_accountHolder.toString());
        }
        if (bankDetails_iban === null || bankDetails_iban === undefined) {
            throw new Error('The parameter "bankDetails_iban" cannot be null.');
        } else {
            content.append("bankDetails.iban", bankDetails_iban.toString());
        }
        if (bankDetails_bic === null || bankDetails_bic === undefined) {
            throw new Error('The parameter "bankDetails_bic" cannot be null.');
        } else {
            content.append("bankDetails.bic", bankDetails_bic.toString());
        }
        if (termsAcceptedProfessionalAccount === null || termsAcceptedProfessionalAccount === undefined) {
            throw new Error('The parameter "termsAcceptedProfessionalAccount" cannot be null.');
        } else {
            content.append("termsAcceptedProfessionalAccount", termsAcceptedProfessionalAccount.toString());
        }
        if (termsAcceptedDebitAuthorization === null || termsAcceptedDebitAuthorization === undefined) {
            throw new Error('The parameter "termsAcceptedDebitAuthorization" cannot be null.');
        } else {
            content.append("termsAcceptedDebitAuthorization", termsAcceptedDebitAuthorization.toString());
        }
        if (termsAcceptedCompanyIsTheOnlyTenant === null || termsAcceptedCompanyIsTheOnlyTenant === undefined) {
            throw new Error('The parameter "termsAcceptedCompanyIsTheOnlyTenant" cannot be null.');
        } else {
            content.append("termsAcceptedCompanyIsTheOnlyTenant", termsAcceptedCompanyIsTheOnlyTenant.toString());
        }
        if (ribFile === null || ribFile === undefined) {
            throw new Error('The parameter "ribFile" cannot be null.');
        } else {
            content.append("ribFile", ribFile.data, ribFile.fileName ? ribFile.fileName : "ribFile");
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Change Contract transfer Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param effectiveDate (optional) 
     * @param buyback (optional) 
     * @param toReturnMaterials (optional) 
     * @param reason (optional) 
     * @param commentary (optional) 
     * @param buyerContact_lastName (optional) 
     * @param buyerContact_firstName (optional) 
     * @param buyerContact_email (optional) 
     * @param buyerContact_phoneNumber (optional) 
     * @param buyerContact_jobTitle (optional) 
     * @param buyerAddress_sirenCode (optional) 
     * @param buyerAddress_businessName (optional) 
     * @param buyerAddress_streetNumber (optional) 
     * @param buyerAddress_streetName (optional) 
     * @param buyerAddress_additionalAddress (optional) 
     * @param buyerAddress_zipCode (optional) 
     * @param buyerAddress_city (optional) 
     * @param kbisFile (optional) 
     * @param businessTakeoverFile (optional) 
     * @param optionalCommentary (optional) 
     * @return No Content
     */
    submitChangeContractTransferRequest(siren: string, contractsIds?: string[] | undefined, hasDocument?: boolean | undefined, effectiveDate?: Date | undefined, buyback?: TypeOfBuyback | null | undefined, toReturnMaterials?: string[] | undefined, reason?: ContractTransferReason | undefined, commentary?: string | null | undefined, buyerContact_lastName?: string | undefined, buyerContact_firstName?: string | undefined, buyerContact_email?: string | undefined, buyerContact_phoneNumber?: string | undefined, buyerContact_jobTitle?: string | undefined, buyerAddress_sirenCode?: string | undefined, buyerAddress_businessName?: string | undefined, buyerAddress_streetNumber?: string | undefined, buyerAddress_streetName?: string | undefined, buyerAddress_additionalAddress?: string | null | undefined, buyerAddress_zipCode?: number | null | undefined, buyerAddress_city?: string | undefined, kbisFile?: FileParameter | undefined, businessTakeoverFile?: FileParameter | null | undefined, optionalCommentary?: string | null | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitChangeContractTransferRequest(
            siren,
            contractsIds,
            hasDocument,
            effectiveDate,
            buyback,
            toReturnMaterials,
            reason,
            commentary,
            buyerContact_lastName,
            buyerContact_firstName,
            buyerContact_email,
            buyerContact_phoneNumber,
            buyerContact_jobTitle,
            buyerAddress_sirenCode,
            buyerAddress_businessName,
            buyerAddress_streetNumber,
            buyerAddress_streetName,
            buyerAddress_additionalAddress,
            buyerAddress_zipCode,
            buyerAddress_city,
            kbisFile,
            businessTakeoverFile,
            optionalCommentary,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error('The parameter "contractsIds" cannot be null.');
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append("contractsIds[" + index_ + "]",item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error('The parameter "hasDocument" cannot be null.');
        } else {
            content.append("hasDocument", hasDocument.toString());
        }
        if (effectiveDate === null || effectiveDate === undefined) {
            throw new Error('The parameter "effectiveDate" cannot be null.');
        } else {
            content.append("effectiveDate", effectiveDate.toJSON());
        }
        if (buyback !== null && buyback !== undefined) {
            content.append("buyback", buyback.toString());
        }
        if (toReturnMaterials === null || toReturnMaterials === undefined) {
            throw new Error('The parameter "toReturnMaterials" cannot be null.');
        } else {
            toReturnMaterials.forEach((item_, index_) => {
                    content.append("toReturnMaterials[" + index_ + "]",item_.toString());
                });
        }
        if (reason === null || reason === undefined) {
            throw new Error('The parameter "reason" cannot be null.');
        } else {
            content.append("reason", reason.toString());
        }
        if (commentary !== null && commentary !== undefined) {
            content.append("commentary", commentary.toString());
        }
        if (buyerContact_lastName === null || buyerContact_lastName === undefined) {
            throw new Error('The parameter "buyerContact_lastName" cannot be null.');
        } else {
            content.append("buyerContact.lastName", buyerContact_lastName.toString());
        }
        if (buyerContact_firstName === null || buyerContact_firstName === undefined) {
            throw new Error('The parameter "buyerContact_firstName" cannot be null.');
        } else {
            content.append("buyerContact.firstName", buyerContact_firstName.toString());
        }
        if (buyerContact_email === null || buyerContact_email === undefined) {
            throw new Error('The parameter "buyerContact_email" cannot be null.');
        } else {
            content.append("buyerContact.email", buyerContact_email.toString());
        }
        if (buyerContact_phoneNumber === null || buyerContact_phoneNumber === undefined) {
            throw new Error('The parameter "buyerContact_phoneNumber" cannot be null.');
        } else {
            content.append("buyerContact.phoneNumber", buyerContact_phoneNumber.toString());
        }
        if (buyerContact_jobTitle === null || buyerContact_jobTitle === undefined) {
            throw new Error('The parameter "buyerContact_jobTitle" cannot be null.');
        } else {
            content.append("buyerContact.jobTitle", buyerContact_jobTitle.toString());
        }
        if (buyerAddress_sirenCode === null || buyerAddress_sirenCode === undefined) {
            throw new Error('The parameter "buyerAddress_sirenCode" cannot be null.');
        } else {
            content.append("buyerAddress.sirenCode", buyerAddress_sirenCode.toString());
        }
        if (buyerAddress_businessName === null || buyerAddress_businessName === undefined) {
            throw new Error('The parameter "buyerAddress_businessName" cannot be null.');
        } else {
            content.append("buyerAddress.businessName", buyerAddress_businessName.toString());
        }
        if (buyerAddress_streetNumber === null || buyerAddress_streetNumber === undefined) {
            throw new Error('The parameter "buyerAddress_streetNumber" cannot be null.');
        } else {
            content.append("buyerAddress.streetNumber", buyerAddress_streetNumber.toString());
        }
        if (buyerAddress_streetName === null || buyerAddress_streetName === undefined) {
            throw new Error('The parameter "buyerAddress_streetName" cannot be null.');
        } else {
            content.append("buyerAddress.streetName", buyerAddress_streetName.toString());
        }
        if (buyerAddress_additionalAddress !== null && buyerAddress_additionalAddress !== undefined) {
            content.append("buyerAddress.additionalAddress", buyerAddress_additionalAddress.toString());
        }
        if (buyerAddress_zipCode !== null && buyerAddress_zipCode !== undefined) {
            content.append("buyerAddress.zipCode", buyerAddress_zipCode.toString());
        }
        if (buyerAddress_city === null || buyerAddress_city === undefined) {
            throw new Error('The parameter "buyerAddress_city" cannot be null.');
        } else {
            content.append("buyerAddress.city", buyerAddress_city.toString());
        }
        if (kbisFile === null || kbisFile === undefined) {
            throw new Error('The parameter "kbisFile" cannot be null.');
        } else {
            content.append("kbisFile", kbisFile.data, kbisFile.fileName ? kbisFile.fileName : "kbisFile");
        }
        if (businessTakeoverFile !== null && businessTakeoverFile !== undefined) {
            content.append("businessTakeoverFile", businessTakeoverFile.data, businessTakeoverFile.fileName ? businessTakeoverFile.fileName : "businessTakeoverFile");
        }
        if (optionalCommentary !== null && optionalCommentary !== undefined) {
            content.append("optionalCommentary", optionalCommentary.toString());
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Change Head office address Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param headOfficeAddress_streetNumber (optional) 
     * @param headOfficeAddress_streetName (optional) 
     * @param headOfficeAddress_additionalAddress (optional) 
     * @param headOfficeAddress_zipCode (optional) 
     * @param headOfficeAddress_city (optional) 
     * @param kbisFile (optional) 
     * @return No Content
     */
    submitChangeHeadOfficeAddressRequest(siren: string, contractsIds?: string[] | undefined, hasDocument?: boolean | undefined, optionalCommentary?: string | undefined, headOfficeAddress_streetNumber?: string | undefined, headOfficeAddress_streetName?: string | undefined, headOfficeAddress_additionalAddress?: string | null | undefined, headOfficeAddress_zipCode?: number | null | undefined, headOfficeAddress_city?: string | undefined, kbisFile?: FileParameter | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitChangeHeadOfficeAddressRequest(
            siren,
            contractsIds,
            hasDocument,
            optionalCommentary,
            headOfficeAddress_streetNumber,
            headOfficeAddress_streetName,
            headOfficeAddress_additionalAddress,
            headOfficeAddress_zipCode,
            headOfficeAddress_city,
            kbisFile,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error('The parameter "contractsIds" cannot be null.');
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append("contractsIds[" + index_ + "]",item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error('The parameter "hasDocument" cannot be null.');
        } else {
            content.append("hasDocument", hasDocument.toString());
        }
        if (optionalCommentary === null || optionalCommentary === undefined) {
            throw new Error('The parameter "optionalCommentary" cannot be null.');
        } else {
            content.append("optionalCommentary", optionalCommentary.toString());
        }
        if (headOfficeAddress_streetNumber === null || headOfficeAddress_streetNumber === undefined) {
            throw new Error('The parameter "headOfficeAddress_streetNumber" cannot be null.');
        } else {
            content.append("headOfficeAddress.streetNumber", headOfficeAddress_streetNumber.toString());
        }
        if (headOfficeAddress_streetName === null || headOfficeAddress_streetName === undefined) {
            throw new Error('The parameter "headOfficeAddress_streetName" cannot be null.');
        } else {
            content.append("headOfficeAddress.streetName", headOfficeAddress_streetName.toString());
        }
        if (headOfficeAddress_additionalAddress !== null && headOfficeAddress_additionalAddress !== undefined) {
            content.append("headOfficeAddress.additionalAddress", headOfficeAddress_additionalAddress.toString());
        }
        if (headOfficeAddress_zipCode !== null && headOfficeAddress_zipCode !== undefined) {
            content.append("headOfficeAddress.zipCode", headOfficeAddress_zipCode.toString());
        }
        if (headOfficeAddress_city === null || headOfficeAddress_city === undefined) {
            throw new Error('The parameter "headOfficeAddress_city" cannot be null.');
        } else {
            content.append("headOfficeAddress.city", headOfficeAddress_city.toString());
        }
        if (kbisFile === null || kbisFile === undefined) {
            throw new Error('The parameter "kbisFile" cannot be null.');
        } else {
            content.append("kbisFile", kbisFile.data, kbisFile.fileName ? kbisFile.fileName : "kbisFile");
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit Change Financial condition Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param financialConditionType (optional) 
     * @param effectiveDate (optional) 
     * @param financialConditionPeriodicity (optional) 
     * @param reason (optional) 
     * @param lastFinancialStatementFile (optional) 
     * @param lastVatStatementsFile (optional) 
     * @return No Content
     */
    submitChangeFinancialConditionRequest(siren: string, contractsIds?: string[] | null | undefined, hasDocument?: boolean | undefined, optionalCommentary?: string | null | undefined, financialConditionType?: FinancialConditionType | null | undefined, effectiveDate?: Date | null | undefined, financialConditionPeriodicity?: FinancialConditionPeriodicity | null | undefined, reason?: string | null | undefined, lastFinancialStatementFile?: FileParameter | null | undefined, lastVatStatementsFile?: FileParameter | null | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitChangeFinancialConditionRequest(
            siren,
            contractsIds,
            hasDocument,
            optionalCommentary,
            financialConditionType,
            effectiveDate,
            financialConditionPeriodicity,
            reason,
            lastFinancialStatementFile,
            lastVatStatementsFile,
        );

        const content = new FormData();
        if (contractsIds !== null && contractsIds !== undefined) {
            contractsIds.forEach((item_, index_) => {
                    content.append("contractsIds[" + index_ + "]",item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error('The parameter "hasDocument" cannot be null.');
        } else {
            content.append("hasDocument", hasDocument.toString());
        }
        if (optionalCommentary !== null && optionalCommentary !== undefined) {
            content.append("optionalCommentary", optionalCommentary.toString());
        }
        if (financialConditionType !== null && financialConditionType !== undefined) {
            content.append("financialConditionType", financialConditionType.toString());
        }
        if (effectiveDate !== null && effectiveDate !== undefined) {
            content.append("effectiveDate", effectiveDate.toJSON());
        }
        if (financialConditionPeriodicity !== null && financialConditionPeriodicity !== undefined) {
            content.append("financialConditionPeriodicity", financialConditionPeriodicity.toString());
        }
        if (reason !== null && reason !== undefined) {
            content.append("reason", reason.toString());
        }
        if (lastFinancialStatementFile !== null && lastFinancialStatementFile !== undefined) {
            content.append("lastFinancialStatementFile", lastFinancialStatementFile.data, lastFinancialStatementFile.fileName ? lastFinancialStatementFile.fileName : "lastFinancialStatementFile");
        }
        if (lastVatStatementsFile !== null && lastVatStatementsFile !== undefined) {
            content.append("lastVatStatementsFile", lastVatStatementsFile.data, lastVatStatementsFile.fileName ? lastVatStatementsFile.fileName : "lastVatStatementsFile");
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit client request file
     * @param type (optional) 
     * @param contractNb (optional) 
     * @param fileToUpload (optional) 
     * @return No Content
     */
    uploadFile(siren: string, type?: UploadFileType | undefined, contractNb?: string | undefined, fileToUpload?: FileParameter | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.uploadFile(
            siren,
            type,
            contractNb,
            fileToUpload,
        );

        const content = new FormData();
        if (fileToUpload === null || fileToUpload === undefined) {
            throw new Error('The parameter "fileToUpload" cannot be null.');
        } else {
            content.append("fileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "fileToUpload");
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }
}

export class CustomerRequestsDetailsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        submitCustomerRequestNonComplianceResponse: (
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/response/non-compliance';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitCustomerRequestBuybackResponse: (
			siren: string,
			caseId?: string | undefined,
			contractId?: string | undefined,
			comment?: string | undefined,
			customerDecision?: CustomerDecision | undefined,
			paymentMethod?: PaymentMethod | null | undefined,
			documents?: UploadFileType[] | undefined,
			letterFile?: FileParameter | null | undefined,
			creditTransferFile?: FileParameter | null | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/{siren}/response/buyback';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDocumentCopyOfContractualElementDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/document-copy-of-contractual-element/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDocumentContractRelatedDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/document-contract-related/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDocumentAccountExtractDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/document-account-extract/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDocumentEquipmentRelatedDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/document-equipment-related/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getBillingBankDetailDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/billing-bank-detail/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getBillingOrderNumberDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/billing-order-number/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getBillingAddressDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/billing-address/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getChangeHeadOfficeAddressDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/change-head-office-address/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getChangeFinancialConditionDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/change-financial-condition/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractReturnOfEquipmentDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-return-of-equipment/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractDenialOfContractRenewalDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-denial-of-contract-renewal/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractEarlyRedemptionDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-early-redemption/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractExerciseOfPurchaseOptionDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-exercise-of-purchase-option/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractTerminationOfContractDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-termination-of-contract/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractTransferDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/contract-transfer/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error('The parameter "caseId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent('' + caseId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Submit response phase one
     * @param body (optional) 
     * @return OK
     */
    submitCustomerRequestNonComplianceResponse(body?: CustomerRequestNonComplianceResponse | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitCustomerRequestNonComplianceResponse(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Submit response phase two
     * @param caseId (optional) 
     * @param contractId (optional) 
     * @param comment (optional) 
     * @param customerDecision (optional) 
     * @param paymentMethod (optional) 
     * @param documents (optional) 
     * @param letterFile (optional) 
     * @param creditTransferFile (optional) 
     * @return OK
     */
    submitCustomerRequestBuybackResponse(siren: string, caseId?: string | undefined, contractId?: string | undefined, comment?: string | undefined, customerDecision?: CustomerDecision | undefined, paymentMethod?: PaymentMethod | null | undefined, documents?: UploadFileType[] | undefined, letterFile?: FileParameter | null | undefined, creditTransferFile?: FileParameter | null | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitCustomerRequestBuybackResponse(
            siren,
            caseId,
            contractId,
            comment,
            customerDecision,
            paymentMethod,
            documents,
            letterFile,
            creditTransferFile,
        );

        const content = new FormData();
        if (caseId === null || caseId === undefined) {
            throw new Error('The parameter "caseId" cannot be null.');
        } else {
            content.append("caseId", caseId.toString());
        }
        if (contractId === null || contractId === undefined) {
            throw new Error('The parameter "contractId" cannot be null.');
        } else {
            content.append("contractId", contractId.toString());
        }
        if (comment === null || comment === undefined) {
            throw new Error('The parameter "comment" cannot be null.');
        } else {
            content.append("comment", comment.toString());
        }
        if (customerDecision === null || customerDecision === undefined) {
            throw new Error('The parameter "customerDecision" cannot be null.');
        } else {
            content.append("customerDecision", customerDecision.toString());
        }
        if (paymentMethod !== null && paymentMethod !== undefined) {
            content.append("paymentMethod", paymentMethod.toString());
        }
        if (documents === null || documents === undefined) {
            throw new Error('The parameter "documents" cannot be null.');
        } else {
            documents.forEach((item_, index_) => {
                    content.append("documents[" + index_ + "]",item_.toString());
                });
        }
        if (letterFile !== null && letterFile !== undefined) {
            content.append("letterFile", letterFile.data, letterFile.fileName ? letterFile.fileName : "letterFile");
        }
        if (creditTransferFile !== null && creditTransferFile !== undefined) {
            content.append("creditTransferFile", creditTransferFile.data, creditTransferFile.fileName ? creditTransferFile.fileName : "creditTransferFile");
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Get Document Copy Of Contractual Element Details
     * @return OK
     */
    getDocumentCopyOfContractualElementDetails(caseId: string): Promise<DocumentCopyOfContractualElementDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getDocumentCopyOfContractualElementDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<DocumentCopyOfContractualElementDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get Document Contract Related Details
     * @return OK
     */
    getDocumentContractRelatedDetails(caseId: string): Promise<DocumentContractRelatedDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getDocumentContractRelatedDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<DocumentContractRelatedDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get Document Account Extract Details
     * @return OK
     */
    getDocumentAccountExtractDetails(caseId: string): Promise<DocumentAccountExtractDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getDocumentAccountExtractDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<DocumentAccountExtractDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'start', 'end']);
        });
    }

    /**
     * Get Document Equipment Related Details
     * @return OK
     */
    getDocumentEquipmentRelatedDetails(caseId: string): Promise<DocumentEquipmentRelatedDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getDocumentEquipmentRelatedDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<DocumentEquipmentRelatedDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'start', 'end']);
        });
    }

    /**
     * Get Billing Bank Detail Details
     * @return OK
     */
    getBillingBankDetailDetails(caseId: string): Promise<BillingBankDetailDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getBillingBankDetailDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<BillingBankDetailDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get Billing Order Number Details
     * @return OK
     */
    getBillingOrderNumberDetails(caseId: string): Promise<BillingOrderNumberDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getBillingOrderNumberDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<BillingOrderNumberDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get Billing Address Details
     * @return OK
     */
    getBillingAddressDetails(caseId: string): Promise<BillingAddressDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getBillingAddressDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<BillingAddressDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get head office address Details
     * @return OK
     */
    getChangeHeadOfficeAddressDetails(caseId: string): Promise<ChangeHeadOfficeAddressDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getChangeHeadOfficeAddressDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ChangeHeadOfficeAddressDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get head office address Details
     * @return OK
     */
    getChangeFinancialConditionDetails(caseId: string): Promise<ChangeFinancialConditionDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getChangeFinancialConditionDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ChangeFinancialConditionDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get End Of Contract Return Of Equipment Details
     * @return OK
     */
    getEndOfContractReturnOfEquipmentDetails(caseId: string): Promise<EndOfContractReturnOfEquipmentDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractReturnOfEquipmentDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<EndOfContractReturnOfEquipmentDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get End Of Contract Denial Of Contract Renewal Details
     * @return OK
     */
    getEndOfContractDenialOfContractRenewalDetails(caseId: string): Promise<EndOfContractDenialOfContractRenewalDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractDenialOfContractRenewalDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<EndOfContractDenialOfContractRenewalDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get End Of Contract Early Redemption Details
     * @return OK
     */
    getEndOfContractEarlyRedemptionDetails(caseId: string): Promise<EndOfContractEarlyRedemptionDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractEarlyRedemptionDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<EndOfContractEarlyRedemptionDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get End Of Contract Return Of Equipment Details
     * @return OK
     */
    getEndOfContractExerciseOfPurchaseOptionDetails(caseId: string): Promise<EndOfContractExerciseOfPurchaseOptionDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractExerciseOfPurchaseOptionDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<EndOfContractExerciseOfPurchaseOptionDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get End Of Contract Termination Of Contract Details
     * @return OK
     */
    getEndOfContractTerminationOfContractDetails(caseId: string): Promise<EndOfContractTerminationOfContractDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractTerminationOfContractDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<EndOfContractTerminationOfContractDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }

    /**
     * Get Contract Transfer Details
     * @return OK
     */
    getContractTransferDetails(caseId: string): Promise<ContractTransferDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractTransferDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ContractTransferDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'nonConformDate', 'lastReminderDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate']);
        });
    }
}

export class FinancialRequestsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        hasRightToSeeFinancialRequests: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/authorization';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitFinancialRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/submit';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getFinancialRequestsCount: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/count';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getFinancialRequests: (
			siren: string,
			skip?: number | undefined,
			take?: number | undefined,
			sortDirection?: SortDirection | undefined,
			sortSource?: FinancialSortingSource | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/list?';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (skip === null) {
                throw new Error('The parameter "skip" cannot be null.');
            } else if (skip !== undefined) {
                clientRequestUrl += 'skip=' + encodeURIComponent('' + skip) + '&';
            }
            if (take === null) {
                throw new Error('The parameter "take" cannot be null.');
            } else if (take !== undefined) {
                clientRequestUrl += 'take=' + encodeURIComponent('' + take) + '&';
            }
            if (sortDirection === null) {
                throw new Error('The parameter "sortDirection" cannot be null.');
            } else if (sortDirection !== undefined) {
                clientRequestUrl += 'sortDirection=' + encodeURIComponent('' + sortDirection) + '&';
            }
            if (sortSource === null) {
                throw new Error('The parameter "sortSource" cannot be null.');
            } else if (sortSource !== undefined) {
                clientRequestUrl += 'sortSource=' + encodeURIComponent('' + sortSource) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getFinancialRequest: (
			siren: string,
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/requests/{id}';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        uploadFile: (
			type?: UploadFileType | undefined,
			requestId?: string | undefined,
			fileToUpload?: FileParameter | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/upload-file?';
            if (type === null) {
                throw new Error('The parameter "type" cannot be null.');
            } else if (type !== undefined) {
                clientRequestUrl += 'type=' + encodeURIComponent('' + type) + '&';
            }
            if (requestId === null) {
                throw new Error('The parameter "requestId" cannot be null.');
            } else if (requestId !== undefined) {
                clientRequestUrl += 'requestId=' + encodeURIComponent('' + requestId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Check if user has right to see financial requests for given siren
     * @return OK
     */
    hasRightToSeeFinancialRequests(siren: string): Promise<RightToSeeFinancialRequest> {
        const clientRequestUrl = this.baseUrl + this.routes.hasRightToSeeFinancialRequests(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<RightToSeeFinancialRequest>(_response, false, []);
        });
    }

    /**
     * Submit financial request
     * @param body (optional) 
     * @return OK
     */
    submitFinancialRequest(siren: string, body?: SaveFinancialRequest | undefined): Promise<SaveFinancialResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.submitFinancialRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SaveFinancialResponse>(_response, false, []);
        });
    }

    /**
     * Get amount of request
     * @return OK
     */
    getFinancialRequestsCount(siren: string): Promise<FinancialRequestCount> {
        const clientRequestUrl = this.baseUrl + this.routes.getFinancialRequestsCount(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<FinancialRequestCount>(_response, false, []);
        });
    }

    /**
     * Get list of request
     * @param skip (optional) 
     * @param take (optional) 
     * @param sortDirection (optional) 
     * @param sortSource (optional) 
     * @return OK
     */
    getFinancialRequests(siren: string, skip?: number | undefined, take?: number | undefined, sortDirection?: SortDirection | undefined, sortSource?: FinancialSortingSource | undefined): Promise<FinancialRequestSummaryPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getFinancialRequests(
            siren,
            skip,
            take,
            sortDirection,
            sortSource,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<FinancialRequestSummaryPaginationResult>(_response, false, ['requestCreationDate']);
        });
    }

    /**
     * Get request detailed
     * @return OK
     */
    getFinancialRequest(siren: string, id: number): Promise<FinancialRequestDetailed> {
        const clientRequestUrl = this.baseUrl + this.routes.getFinancialRequest(
            siren,
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<FinancialRequestDetailed>(_response, false, ['requestCreationDate', 'birthDate', 'endValidityDate']);
        });
    }

    /**
     * Submit financial request file
     * @param type (optional) 
     * @param requestId (optional) 
     * @param fileToUpload (optional) 
     * @return No Content
     */
    uploadFile(type?: UploadFileType | undefined, requestId?: string | undefined, fileToUpload?: FileParameter | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.uploadFile(
            type,
            requestId,
            fileToUpload,
        );

        const content = new FormData();
        if (fileToUpload === null || fileToUpload === undefined) {
            throw new Error('The parameter "fileToUpload" cannot be null.');
        } else {
            content.append("fileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "fileToUpload");
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }
}

export class HealthClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
        ): string => {
            let clientRequestUrl = '/api/v1/health';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDetailed: (
        ): string => {
            let clientRequestUrl = '/api/v1/health/details';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getLiveness: (
        ): string => {
            let clientRequestUrl = '/api/v1/health/liveness';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getReadiness: (
        ): string => {
            let clientRequestUrl = '/api/v1/health/readiness';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get Health status
     * @return OK
     */
    get(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }

    /**
     * Get Health detailed status
     * @return OK
     */
    getDetailed(): Promise<HealthStatusReportDetailed> {
        const clientRequestUrl = this.baseUrl + this.routes.getDetailed(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReportDetailed>(_response, false, ['executionDateTimeUtc']);
        });
    }

    /**
     * Get liveness
     * @return OK
     */
    getLiveness(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.getLiveness(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }

    /**
     * Get readiness
     * @return OK
     */
    getReadiness(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.getReadiness(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }
}

export class HomeClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getPresentationCards: (
        ): string => {
            let clientRequestUrl = '/api/v1/home/presentation-cards';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get home presentation cards
     * @return OK
     */
    getPresentationCards(): Promise<PresentationCardsResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getPresentationCards(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<PresentationCardsResult>(_response, false, []);
        });
    }
}

export class InvoicesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getInvoices: (
			siren: string,
			contractId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/contractId/{contractId}';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (contractId === undefined || contractId === null) {
                throw new Error('The parameter "contractId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{contractId}', encodeURIComponent('' + contractId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        search: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/do-get-search';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        downloadInvoice: (
			siren: string,
			documentId?: string | undefined,
			invoiceId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/download?';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            if (documentId === null) {
                throw new Error('The parameter "documentId" cannot be null.');
            } else if (documentId !== undefined) {
                clientRequestUrl += 'documentId=' + encodeURIComponent('' + documentId) + '&';
            }
            if (invoiceId === null) {
                throw new Error('The parameter "invoiceId" cannot be null.');
            } else if (invoiceId !== undefined) {
                clientRequestUrl += 'invoiceId=' + encodeURIComponent('' + invoiceId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        downloadInvoices: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/do-download';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getManagementCompany: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/management-company';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get invoices
     * @return OK
     */
    getInvoices(siren: string, contractId: string): Promise<InvoicePaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getInvoices(
            siren,
            contractId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<InvoicePaginationResult>(_response, false, ['termDate']);
        });
    }

    /**
     * Download multiple invoices document
     * @param body (optional) 
     * @return OK
     */
    search(siren: string, body?: SearchInvoicesRequest | undefined): Promise<InvoicePaginationNextResult> {
        const clientRequestUrl = this.baseUrl + this.routes.search(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<InvoicePaginationNextResult>(_response, false, ['termDate']);
        });
    }

    /**
     * Download invoice document
     * @param documentId (optional) 
     * @param invoiceId (optional) 
     * @return OK
     */
    downloadInvoice(siren: string, documentId?: string | undefined, invoiceId?: string | undefined): Promise<FileResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.downloadInvoice(
            siren,
            documentId,
            invoiceId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<FileResponse>(_response, true, ['start', 'end']);
        });
    }

    /**
     * Download multiple invoices document
     * @param body (optional) 
     * @return OK
     */
    downloadInvoices(siren: string, body?: DownloadInvoiceDocumentRequest[] | undefined): Promise<FileResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.downloadInvoices(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<FileResponse>(_response, true, ['start', 'end']);
        });
    }

    /**
     * Get Default Management Company
     * @return OK
     */
    getManagementCompany(siren: string): Promise<ManagementCompanyResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getManagementCompany(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ManagementCompanyResponse>(_response, false, []);
        });
    }
}

export class LogsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        error: (
        ): string => {
            let clientRequestUrl = '/api/v1/logs/_error';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        info: (
        ): string => {
            let clientRequestUrl = '/api/v1/logs/_info';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        functional: (
        ): string => {
            let clientRequestUrl = '/api/v1/logs/_functional';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Log error
     * @param body (optional) Details of the error that occurred
     * @return No Content
     */
    error(body?: ClientLogError | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.error(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Log info
     * @param body (optional) Information log to create
     * @return No Content
     */
    info(body?: ClientLog | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.info(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }

    /**
     * Log functional
     * @param body (optional) Functional log to create
     * @return No Content
     */
    functional(body?: ClientLogFunctional | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.functional(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, ['start', 'end']);
        });
    }
}

export class PersonsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getNavigateAsPersons: (
			searchTerms?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/persons/navigate-as?';
            if (searchTerms === null) {
                throw new Error('The parameter "searchTerms" cannot be null.');
            } else if (searchTerms !== undefined) {
                clientRequestUrl += 'searchTerms=' + encodeURIComponent('' + searchTerms) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getPerson: (
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v1/persons/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get persons the current user can impersonate
     * @param searchTerms (optional) 
     * @return OK
     */
    getNavigateAsPersons(searchTerms?: string | undefined): Promise<NavigateAsPersons> {
        const clientRequestUrl = this.baseUrl + this.routes.getNavigateAsPersons(
            searchTerms,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<NavigateAsPersons>(_response, false, []);
        });
    }

    /**
     * Get person
     * @return OK
     */
    getPerson(id: string): Promise<Person> {
        const clientRequestUrl = this.baseUrl + this.routes.getPerson(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<Person>(_response, false, []);
        });
    }
}

export class ReferentialsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getAssetNatures: (
			famillyId?: number | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/referentials/asset-natures?';
            if (famillyId === null) {
                throw new Error('The parameter "famillyId" cannot be null.');
            } else if (famillyId !== undefined) {
                clientRequestUrl += 'famillyId=' + encodeURIComponent('' + famillyId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAssetFamilies: (
        ): string => {
            let clientRequestUrl = '/api/v1/referentials/asset-families';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get asset natures
     * @param famillyId (optional) 
     * @return OK
     */
    getAssetNatures(famillyId?: number | undefined): Promise<AssetNaturePaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getAssetNatures(
            famillyId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<AssetNaturePaginationResult>(_response, false, []);
        });
    }

    /**
     * Get asset families
     * @return OK
     */
    getAssetFamilies(): Promise<AssetFamilyPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getAssetFamilies(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<AssetFamilyPaginationResult>(_response, false, []);
        });
    }
}

export class SimulationsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getSimulation: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/simulations/{siren}/do-get-simulation';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSavedSimulations: (
        ): string => {
            let clientRequestUrl = '/api/v1/simulations';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get simulation
     * @param body (optional) 
     * @return OK
     */
    getSimulation(siren: string, body?: SimulationRequest | undefined): Promise<SimulationResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSimulation(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SimulationResponse>(_response, false, []);
        });
    }

    /**
     * Get saved simulations
     * @return OK
     */
    getSavedSimulations(): Promise<SimulationRequestPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getSavedSimulations(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SimulationRequestPaginationResult>(_response, false, []);
        });
    }
}

export class SubscribeCodeClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getSubscribeCode: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscribe-code/{siren}';
            if (siren === undefined || siren === null) {
                throw new Error('The parameter "siren" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent('' + siren));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get code
     * @return OK
     */
    getSubscribeCode(siren: string): Promise<SubscribeCode> {
        const clientRequestUrl = this.baseUrl + this.routes.getSubscribeCode(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SubscribeCode>(_response, false, []);
        });
    }
}

export interface AccountExtractRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    start: Date;
    end: Date;
    customerReference?: string | undefined;
}

export interface ActDetail {
    reference?: RequestType | undefined;
    label?: string | undefined;
    category?: string | undefined;
}

export interface Address {
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    additionalAddress?: string | undefined;
    zipCode?: number | undefined;
    city?: string | undefined;
}

export enum AmortizationCode {
    L = "L",
}

export interface Amount {
    currency?: string | undefined;
    value?: number | undefined;
}

/** App context */
export interface AppContext {
    /** Logged user */
    loggedUser?: LoggedUser | undefined;
    /** Environment */
    environment?: string | undefined;
}

export interface Asset {
    name?: string | undefined;
    serialNumber?: string | undefined;
    amountExTax?: Amount | undefined;
    supplierName?: string | undefined;
    registrationNumber?: string | undefined;
    nature?: string | undefined;
}

export interface AssetFamily {
    id: number;
    name?: string | undefined;
}

export interface AssetFamilyPaginationResult {
    results?: AssetFamily[] | undefined;
    totalResults?: number | undefined;
    skip: number;
    take: number;
}

export interface AssetNature {
    id?: number | undefined;
    name?: string | undefined;
    familyId: number;
    code?: string | undefined;
}

export interface AssetNaturePaginationResult {
    results?: AssetNature[] | undefined;
    totalResults?: number | undefined;
    skip: number;
    take: number;
}

export interface BankDetails {
    accountHolder?: string | undefined;
    iban?: string | undefined;
    bic?: string | undefined;
}

export interface BankDetailsRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    bankDetails?: BankDetails | undefined;
    /** Je certifie que ce compte est un compte professionnel et que notre société en est le titulaire. */
    termsAcceptedProfessionalAccount: boolean;
    /** Je certifie que notre société autorise le prélèvement des loyers de son(ses) contrat(s) sur les nouvelles coordonnées bancaires communiquées. */
    termsAcceptedDebitAuthorization: boolean;
    /** Je confirme que notre société reste l’utilisatrice des matériels loués (pas de changement de locataire à déclarer). */
    termsAcceptedCompanyIsTheOnlyTenant: boolean;
    ribFile?: string | undefined;
}

export interface BaseRequestDetails {
    phaseNumber: Phase;
    caseId?: string | undefined;
    initiatedBy?: string | undefined;
    managementCompany?: string | undefined;
    mainBusinessNb?: string | undefined;
    folderNo?: string | undefined;
    frontStatus?: FrontStatus | undefined;
    frontStatutDetail?: FrontStatutDetail | undefined;
    statusTimeStamp?: Date | undefined;
    siren?: string | undefined;
    customerName?: string | undefined;
    sellerCode?: string | undefined;
    sellerName?: string | undefined;
    lastUnreadDocReceptionDate?: Date | undefined;
    dateOfReception?: Date | undefined;
    creationDate?: Date | undefined;
    lastNonComplainDate?: Date | undefined;
    customerFeedbackType?: FeedbackType | undefined;
    isScliFeedBack?: boolean | undefined;
    isCustomerInstruction?: boolean | undefined;
    isLastCustomerNonComplainFeedBack?: boolean | undefined;
    isWaitingDocuments?: boolean | undefined;
    isMissingDocuments?: boolean | undefined;
    isIncorrectDocuments?: boolean | undefined;
    statusMessageCode?: string | undefined;
    statusMessage?: string | undefined;
    nonComplainMessageCode?: string | undefined;
    nonComplainMessage?: string | undefined;
    actDetail?: ActDetail | undefined;
    requestorDetails?: RequestorDetails | undefined;
    clientSiteDetails?: ClientSiteDetails | undefined;
    waitingDocuments?: ScliDocument[] | undefined;
    missingDocuments?: ScliDocument[] | undefined;
    incorrectDocuments?: ScliIncorrectDocument[] | undefined;
}

export interface BillingAddressDetails extends BaseRequestDetails {
    request?: BillingAddressRequest | undefined;
}

export interface BillingAddressRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    billingAddress?: Address | undefined;
    deliveryAddress?: Address | undefined;
    hasDeliveryAddress: boolean;
    /** Je confirme que notre société reste l’utilisatrice des matériels loués (pas de changement de locataire à déclarer). */
    termsAccepted: boolean;
}

export interface BillingBankDetailDetails extends BaseRequestDetails {
    request?: BankDetailsRequest | undefined;
}

export interface BillingOrderNumberDetails extends BaseRequestDetails {
    request?: OrderNumberRequest | undefined;
}

export enum BusinessTerm {
    BeDue = "BeDue",
    Expired = "Expired",
}

export interface ChangeFinancialConditionDetails extends BaseRequestDetails {
    request?: FinancialConditionRequest | undefined;
}

export interface ChangeHeadOfficeAddressDetails extends BaseRequestDetails {
    request?: HeadOfficeAddressRequest | undefined;
}

/** Client log */
export interface ClientLog {
    /** Message */
    message?: string | undefined;
    /** Custom Parameters */
    customParameters?: { [key: string]: any; } | undefined;
}

export interface ClientLogError extends ClientLog {
    /** Name */
    name?: string | undefined;
    /** Stack Trace */
    stackTrace?: string | undefined;
    /** Page Url */
    pageUrl?: string | undefined;
}

export interface ClientLogFunctional extends ClientLog {
    /** Feature */
    feature?: string | undefined;
}

export interface ClientSiteDetails {
    generalInformations?: GeneralInformation[] | undefined;
    thirdPartyAddresses?: ThirdPartyAddress[] | undefined;
    additionalContacts?: ContactAdapter[] | undefined;
    recipientAddresses?: RecipientAddress[] | undefined;
    others?: Others[] | undefined;
    scliFeedbacks?: ScliFeedback[] | undefined;
    customerInstructions?: Instruction[] | undefined;
    lastCustomerNonComplainFeedBacks?: LastNonComplainFd[] | undefined;
}

export enum ConditionState {
    New = "New",
    SecondHand = "SecondHand",
}

export interface Contact {
    lastName?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
}

export interface ContactAdapter {
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phoneNb?: string | undefined;
}

export interface Contract {
    id?: string | undefined;
    financialType?: FinancialType | undefined;
    provider?: string | undefined;
    assetNatureId?: string | undefined;
    financialRentGlobal?: Amount | undefined;
    unpaidAmount?: Amount | undefined;
    rentalEndDate?: Date | undefined;
    supplierName?: string | undefined;
    inMandate: boolean;
}

export interface ContractAssets {
    id?: string | undefined;
    assets?: Asset[] | undefined;
}

export interface ContractBilling {
    contractId?: string | undefined;
    financialRentExTax?: Amount | undefined;
    businessTerm?: BusinessTerm | undefined;
    financialRentGlobalExTax?: Amount | undefined;
    maintenanceRentExTax?: Amount | undefined;
    equipmentInsurance?: Amount | undefined;
    electronicBillEmail?: string | undefined;
    thirdPartyRecipient?: string | undefined;
    billedThirdParty?: string | undefined;
    thirdPartyPayer?: string | undefined;
    rib?: string | undefined;
    purchaseOrder?: string | undefined;
    billedAddress?: string | undefined;
    division?: string | undefined;
    financialLossInsuranceBonus?: Amount | undefined;
    insuranceBenefitAmount?: Amount | undefined;
}

export interface ContractInformation extends Contract {
    siren?: string | undefined;
    partnerReference?: string | undefined;
    customerReference?: string | undefined;
    rentalStartDate?: Date | undefined;
    nextDueDate?: Date | undefined;
    periodicity?: Periodicity | undefined;
    businessTerm?: BusinessTerm | undefined;
    paymentMethod?: string | undefined;
    initialRentalBase?: Amount | undefined;
    businessDuration?: number | undefined;
    remainingRents?: number | undefined;
    residualValueAmount?: Amount | undefined;
    insuranceBorrower?: string | undefined;
    insuranceEquipment?: string | undefined;
    borrowerInsuranceBonus?: Amount | undefined;
    assetInsuranceBonus?: string | undefined;
    servicePackageAmount?: Amount | undefined;
    managementCompany?: string | undefined;
    managementCompanyName?: string | undefined;
    financialLoss?: string | undefined;
    customerThirdPartyName?: string | undefined;
}

export interface ContractPaginationResult {
    results?: Contract[] | undefined;
    totalResults?: number | undefined;
    skip: number;
    take: number;
}

export enum ContractRelatedDocument {
    RentalCertificate = "RentalCertificate",
    ResearchTaxCredit = "ResearchTaxCredit",
    EndOfRentalCertificate = "EndOfRentalCertificate",
    TaxReinstatement = "TaxReinstatement",
    OffBalanceSheet = "OffBalanceSheet",
}

export interface ContractRelatedRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    documents?: ContractRelatedDocument[] | undefined;
}

export enum ContractSortingSource {
    BusinessNumber = "BusinessNumber",
    ProductName = "ProductName",
    FinancialRentEtAmount = "FinancialRentEtAmount",
    UnpaidTaxIncludedAmount = "UnpaidTaxIncludedAmount",
    RentalEndDate = "RentalEndDate",
}

export interface ContractTransferDetails extends BaseRequestDetails {
    request?: ContractTransferRequest | undefined;
}

export enum ContractTransferReason {
    UniversalAssetTransfer = "UniversalAssetTransfer",
    TransferOfBusinessAssets = "TransferOfBusinessAssets",
    ChangeOfLegalForm = "ChangeOfLegalForm",
    TerminationOfActivity = "TerminationOfActivity",
    InternalGroupReorganization = "InternalGroupReorganization",
    Other = "Other",
}

export interface ContractTransferRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    effectiveDate: Date;
    buyback?: TypeOfBuyback | undefined;
    toReturnMaterials?: string[] | undefined;
    reason: ContractTransferReason;
    commentary?: string | undefined;
    buyerContact?: Contact | undefined;
    buyerAddress?: ThirdAddress | undefined;
    kbisFile?: string | undefined;
    businessTakeoverFile?: string | undefined;
    optionalCommentary?: string | undefined;
}

export interface ContractsIds {
    ids?: string[] | undefined;
}

export interface ContractsStatus {
    type: KpiStatusType;
    value: number;
}

export interface ContractsStatuses {
    statuses?: ContractsStatus[] | undefined;
}

export enum CopyOfContractualElementDocument {
    Contract = "Contract",
    Timeline = "Timeline",
    AnnualReviewLetter = "AnnualReviewLetter",
    Other = "Other",
}

export interface CopyOfContractualElementRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    documents?: CopyOfContractualElementDocument[] | undefined;
    reason?: string | undefined;
}

export enum CustomerDecision {
    Accept = "Accept",
    AbortCase = "AbortCase",
}

export enum CustomerRequestFrontStatus {
    ActionRequired = "ActionRequired",
    InProgress = "InProgress",
    Done = "Done",
    Cancelled = "Cancelled",
}

export enum CustomerRequestKpi {
    InProcess = "InProcess",
    ActionRequired = "ActionRequired",
}

export interface CustomerRequestList {
    count?: number | undefined;
    customerRequestsSummaries?: CustomerRequestsSummary[] | undefined;
}

export interface CustomerRequestNonComplianceResponse {
    caseId?: string | undefined;
    comment?: string | undefined;
    documents?: UploadFileType[] | undefined;
}

export interface CustomerRequestStatus {
    type: CustomerRequestKpi;
    value: number;
}

export interface CustomerRequestStatuses {
    statuses?: CustomerRequestStatus[] | undefined;
}

export interface CustomerRequestsCount {
    value?: number | undefined;
}

export interface CustomerRequestsSummary {
    id?: string | undefined;
    label?: string | undefined;
    requestType?: RequestType | undefined;
    contractId?: string | undefined;
    date?: Date | undefined;
    latestUpdate?: Date | undefined;
    status?: CustomerRequestFrontStatus | undefined;
}

export interface Decision {
    endValidityDate?: Date | undefined;
    funding?: Funding | undefined;
}

export interface DenialOfContractRenewalRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    /** Je déclare que notre société {0} dénonce le renouvellement du (des) contrat(s) listé(s) ci-dessus. */
    termsAccepted: boolean;
}

export interface ErrorDto {
    code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ErrorDto[] | undefined;
}

export interface DetailedError extends ErrorDto {
    detailedMessage?: string | undefined;
    stackTrace?: string | undefined;
}

export interface DocumentAccountExtractDetails extends BaseRequestDetails {
    request?: AccountExtractRequest | undefined;
}

export interface DocumentContractRelatedDetails extends BaseRequestDetails {
    request?: ContractRelatedRequest | undefined;
}

export interface DocumentCopyOfContractualElementDetails extends BaseRequestDetails {
    request?: CopyOfContractualElementRequest | undefined;
}

export interface DocumentEquipmentRelatedDetails extends BaseRequestDetails {
    request?: EquipmentRelatedRequest | undefined;
}

export interface DownloadInvoiceDocumentRequest {
    documentId?: string | undefined;
    invoiceId?: string | undefined;
}

export interface EarlyRedemptionRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    effectiveDate: Date;
    buyback?: TypeOfBuyback | undefined;
    toReturnMaterials?: string[] | undefined;
}

export interface EndOfContractDenialOfContractRenewalDetails extends BaseRequestDetails {
    request?: DenialOfContractRenewalRequest | undefined;
}

export interface EndOfContractEarlyRedemptionDetails extends BaseRequestDetails {
    request?: EarlyRedemptionRequest | undefined;
}

export interface EndOfContractExerciseOfPurchaseOptionDetails extends BaseRequestDetails {
    request?: ExerciseOfPurchaseOptionRequest | undefined;
}

export interface EndOfContractReturnOfEquipmentDetails extends BaseRequestDetails {
    request?: ReturnOfEquipmentRequest | undefined;
}

export interface EndOfContractTerminationOfContractDetails extends BaseRequestDetails {
    request?: TerminationOfContractRequest | undefined;
}

export interface Equipment {
    id?: number | undefined;
    isSecondHand?: boolean | undefined;
    year?: number | undefined;
}

export enum EquipmentRelatedDocument {
    CertificateOfTransfer = "CertificateOfTransfer",
    AxleTax = "AxleTax",
    Ticpetipp = "Ticpetipp",
    RegistrationOrder = "RegistrationOrder",
    PickUpOrder = "PickUpOrder",
    ExitFromTerritory = "ExitFromTerritory",
}

export interface EquipmentRelatedRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    documents?: EquipmentRelatedDocument[] | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
}

export interface ExerciseOfPurchaseOptionRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    /** Je déclare que notre société {0} opte pour l’achat du matériel objet du/des contrat(s) listé(s) ci-dessus. */
    termsAccepted: boolean;
}

export enum FeedbackType {
    NonCompliance = "NonCompliance",
    Instruction = "Instruction",
}

export enum FinancialConditionPeriodicity {
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    BiAnnual = "BiAnnual",
    Yearly = "Yearly",
}

export interface FinancialConditionRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    financialConditionType?: FinancialConditionType | undefined;
    effectiveDate?: Date | undefined;
    financialConditionPeriodicity?: FinancialConditionPeriodicity | undefined;
    reason?: string | undefined;
    lastFinancialStatementFile?: string | undefined;
    lastVatStatementsFile?: string | undefined;
}

export enum FinancialConditionType {
    EffectiveDate = "EffectiveDate",
    Periodicity = "Periodicity",
    RentAmountOrDuration = "RentAmountOrDuration",
}

export interface FinancialRequestCount {
    value?: number | undefined;
}

export interface FinancialRequestDetailed {
    internalReferenceId?: string | undefined;
    externalReferenceId?: string | undefined;
    media: Media;
    manager?: Manager | undefined;
    funding?: Funding | undefined;
    equipment?: Equipment | undefined;
    requestCreationDate?: Date | undefined;
    decision?: Decision | undefined;
    status?: Status | undefined;
}

export interface FinancialRequestSummary {
    internalReferenceId?: string | undefined;
    requestCreationDate: Date;
    status?: Status | undefined;
    funding?: Amount | undefined;
}

export interface FinancialRequestSummaryPaginationResult {
    results?: FinancialRequestSummary[] | undefined;
    totalResults?: number | undefined;
    skip: number;
    take: number;
}

export enum FinancialSortingSource {
    InternalReferenceId = "InternalReferenceId",
    CompanyName = "CompanyName",
    RequestCreationDate = "RequestCreationDate",
    StatusLabel = "StatusLabel",
    Amount = "Amount",
    EquipmentName = "EquipmentName",
}

export enum FinancialType {
    Leasing = "Leasing",
    Rent = "Rent",
    Loan = "Loan",
    DedicatedLoan = "DedicatedLoan",
}

export interface FinancialTypeCountResponse {
    financialTypeCounts?: FinancialTypeCounts | undefined;
}

export enum FrontStatus {
    WorkInProgress = "WorkInProgress",
    ActionRequired = "ActionRequired",
    Done = "Done",
    Canceled = "Canceled",
}

export enum FrontStatutDetail {
    NewContractEdited = "NewContractEdited",
}

export interface Funding {
    amount?: Amount | undefined;
    duration?: number | undefined;
    productCode?: FinancialType | undefined;
    productName?: string | undefined;
    residualValueRate?: number | undefined;
    firstIncreasedRentRate?: number | undefined;
    amortizationCode?: AmortizationCode | undefined;
}

export interface GeneralInformation {
    businessNbList?: string | undefined;
    clientReference?: string | undefined;
    type?: string | undefined;
    assetNature?: string | undefined;
    requestReason?: string | undefined;
    motivationFreeInput?: string | undefined;
    effectiveDate?: Date | undefined;
    contactType?: string | undefined;
    siren?: string | undefined;
    clientName?: string | undefined;
    orderNumber?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    birthDate?: Date | undefined;
    bankAccountOwner?: string | undefined;
    bicOfOwner?: string | undefined;
    ibanOfOwner?: string | undefined;
}

export interface HeadOfficeAddressRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    headOfficeAddress?: Address | undefined;
    kbisFile?: string | undefined;
}

export interface HealthCheckReportEntryDetailed {
    name?: string | undefined;
    status: HealthStatus;
    type?: string | undefined;
    description?: string | undefined;
    tags?: string[] | undefined;
    data?: { [key: string]: any; } | undefined;
    problems?: Problem[] | undefined;
}

export enum HealthStatus {
    Unhealthy = "Unhealthy",
    Degraded = "Degraded",
    Healthy = "Healthy",
}

export interface HealthStatusReport {
    status: HealthStatus;
}

export interface HealthStatusReportDetailed {
    status: HealthStatus;
    executionDateTimeUtc: Date;
    apiCode?: string | undefined;
    checks?: HealthCheckReportEntryDetailed[] | undefined;
}

export interface IncorrectControl {
    controlId?: string | undefined;
    label?: string | undefined;
    comments?: string | undefined;
}

export interface Instruction {
    instructionDate?: Date | undefined;
    decision?: string | undefined;
    paymentMode?: string | undefined;
    instructionAttachment?: boolean | undefined;
    instructionComment?: string | undefined;
    documentTypes?: string[] | undefined;
}

export interface Invoice {
    id?: string | undefined;
    invoiceId?: string | undefined;
    documentId?: string | undefined;
    termDate?: Date | undefined;
    amountFreeTax?: Amount | undefined;
    documentType?: string | undefined;
    contractNb?: string | undefined;
}

export interface InvoicePaginationNextResult {
    results?: Invoice[] | undefined;
    hasNextValue?: boolean | undefined;
    inMandate?: boolean | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export interface InvoicePaginationResult {
    results?: Invoice[] | undefined;
    totalResults?: number | undefined;
    skip: number;
    take: number;
}

export enum KpiStatusType {
    OnGoing = "OnGoing",
    ExpiringSoon = "ExpiringSoon",
    ToBeRegularised = "ToBeRegularised",
}

export interface LastNonComplainFd {
    lastNonComplainFdDate?: Date | undefined;
    lastNonComplainFdAttachment?: boolean | undefined;
    lastNonComplainFdComment?: string | undefined;
    documentTypes?: string[] | undefined;
}

export interface UserInfo {
    id: string;
    email?: string | undefined;
    permissions?: Permission[] | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    clientName?: string | undefined;
    siren?: string | undefined;
    jobTitle?: string | undefined;
    mandates?: MandateInfo[] | undefined;
    isInternal: boolean;
}

export interface LoggedUser extends UserInfo {
    impersonatedBy?: UserInfo | undefined;
}

/** MaintenanceConfigurationResponse */
export interface MaintenanceConfigurationResponse {
    /** Is in maintenance toggle */
    isInMaintenance: boolean;
    /** End date of maintenance */
    maintenanceEndDate?: Date | undefined;
    /** List of whitelisted icIds who do not see the maintenance page */
    whitelistIcIds?: string[] | undefined;
}

export interface ManagementCompanyResponse {
    managementCompany?: string | undefined;
}

export interface Manager {
    birthName?: string | undefined;
    usualName?: string | undefined;
    firstName?: string | undefined;
    birthDate?: Date | undefined;
}

export interface MandateInfo {
    clientSiren?: string | undefined;
    clientName?: string | undefined;
}

export enum Media {
    WSFL = "WSFL",
    MAIL = "MAIL",
    FAX = "FAX",
    TEL = "TEL",
    MOST = "MOST",
    FRT = "FRT",
}

/** Persons the current user can impersonate */
export interface NavigateAsPersons {
    /** Persons */
    persons?: Person[] | undefined;
}

export interface OrderNumberRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    orderNumber?: string | undefined;
    validityPeriod?: ValidityPeriod | undefined;
    orderFormFile?: string | undefined;
}

export interface Others {
    isAttachment?: boolean | undefined;
    comment?: string | undefined;
}

export enum PaymentMethod {
    DirectDebits = "DirectDebits",
    CreditTransfer = "CreditTransfer",
}

export enum Periodicity {
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Yearly = "Yearly",
}

export interface Permission {
    name?: string | undefined;
    constraints?: string[] | undefined;
}

/** Person */
export interface Person {
    /** IC Id */
    icId: string;
    /** FirstName */
    firstName?: string | undefined;
    /** LastName */
    lastName?: string | undefined;
    /** ClientName */
    clientName?: string | undefined;
    /** Email */
    email?: string | undefined;
}

export enum Phase {
    PhaseOne = "PhaseOne",
    PhaseTwo = "PhaseTwo",
    PhaseThree = "PhaseThree",
}

export interface PresentationCard {
    name?: string | undefined;
    imageUrl?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    bullets?: string[] | undefined;
    author?: string | undefined;
}

/** Presentation cards */
export interface PresentationCardsResult {
    /** Presentation cards */
    presentationCards?: PresentationCard[] | undefined;
}

export interface Problem {
    detail?: string | undefined;
}

export interface RecipientAddress {
    streetNb?: string | undefined;
    streetName?: string | undefined;
    additionalAdress?: string | undefined;
    zipCode?: number | undefined;
    city?: string | undefined;
}

export enum RequestType {
    AttestationContrat = "AttestationContrat",
    Attestation = "Attestation",
    AttestationMateriel = "AttestationMateriel",
    DuplicataDePieces = "DuplicataDePieces",
    Deces = "Deces",
    SinistresMateriels = "SinistresMateriels",
    Incapacite = "Incapacite",
    AnnulationDeTaciteReconductionDuContrat = "AnnulationDeTaciteReconductionDuContrat",
    Cac = "Cac",
    LeveeOption = "LeveeOption",
    ChangementDAdresse = "ChangementDAdresse",
    ChangementDenominationSociale = "ChangementDenominationSociale",
    ChangementDeGeranceOuActionnariat = "ChangementDeGeranceOuActionnariat",
    NumeroCommande = "NumeroCommande",
    ModificationFacturation = "ModificationFacturation",
    Reamenagement = "Reamenagement",
    ModificationDuModeDeReglement = "ModificationDuModeDeReglement",
    ChangementDeRib = "ChangementDeRib",
    Prolongation = "Prolongation",
    RachatAnticipation = "RachatAnticipation",
    ResiliationAnticipee = "ResiliationAnticipee",
    RestitutionDeMateriel = "RestitutionDeMateriel",
    Transfert = "Transfert",
    ChangementDeQuantieme = "ChangementDeQuantieme",
    ChangementDePeriodicite = "ChangementDePeriodicite",
    Denonciation = "Denonciation",
}

export interface RequestorDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNb?: string | undefined;
    jobTitle?: string | undefined;
    currentOperatorLabel?: string | undefined;
}

export interface ReturnOfEquipmentRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
}

/** Right To See Financial Request */
export interface RightToSeeFinancialRequest {
    /** Can See Financial Request */
    canSeeFinancialRequest: boolean;
}

export interface SaveFinancialRequest {
    financialType: FinancialType;
    assetNatureId?: string | undefined;
    amount: number;
    duration: number;
    state: ConditionState;
    conditionStateDate?: Date | undefined;
}

/** SaveFinancialResponse */
export interface SaveFinancialResponse {
    /** Request Id */
    readonly requestId?: string | undefined;
}

export interface ScliDocument {
    document?: string | undefined;
    documentLabel?: string | undefined;
    comments?: string | undefined;
    nonConformDate?: Date | undefined;
    lastReminderDate?: Date | undefined;
    reminderCount?: number | undefined;
    recipientName?: string | undefined;
    lastReminderRecipientEmail?: string | undefined;
    documentType?: UploadFileType | undefined;
}

export interface ScliFeedback {
    scliFeedbackDate?: Date | undefined;
    repairability?: boolean | undefined;
    effectiveDate?: Date | undefined;
    amountExcludingTaxes?: number | undefined;
    amountWithTaxes?: number | undefined;
    netAmount?: number | undefined;
    scliDecision?: string | undefined;
    intermediarySettlement?: number | undefined;
    finalSettlement?: number | undefined;
    comment?: string | undefined;
}

export interface ScliIncorrectDocument {
    document?: string | undefined;
    documentLabel?: string | undefined;
    documentType?: UploadFileType | undefined;
    comments?: string | undefined;
    nonConformDate?: Date | undefined;
    lastReminderDate?: Date | undefined;
    reminderCount?: number | undefined;
    recipientName?: string | undefined;
    lastReminderRecipientEmail?: string | undefined;
    incorrectControls?: IncorrectControl[] | undefined;
}

export interface SearchContractRequest {
    businessNumber?: string | undefined;
    financialType?: FinancialType | undefined;
    endDateMin?: Date | undefined;
    endDateMax?: Date | undefined;
    status?: StatusType | undefined;
    skip: number;
    take: number;
    managementCompany?: string | undefined;
    sortDirection: SortDirection;
    sortSource: ContractSortingSource;
}

export interface SearchInvoicesRequest {
    take?: number | undefined;
    skip?: number | undefined;
    contractId?: string | undefined;
    invoiceNb?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    managementCompany?: string | undefined;
}

export interface SimulationRequest {
    financialType: FinancialType;
    amount: number;
    duration: number;
}

export interface SimulationRequestPaginationResult {
    results?: SimulationRequest[] | undefined;
    totalResults?: number | undefined;
    skip: number;
    take: number;
}

export interface SimulationResponse {
    amount?: Amount | undefined;
    duration: number;
}

export enum SortDirection {
    Asc = "Asc",
    Desc = "Desc",
}

export interface Status {
    statusCode?: string | undefined;
    statusLabel?: string | undefined;
    statusComment?: string | undefined;
}

export enum StatusType {
    ExpiringSoon = "ExpiringSoon",
    ToBeRegularised = "ToBeRegularised",
}

export interface SubscribeCode {
    code?: string | undefined;
    managementCompany?: string | undefined;
}

export interface TerminationOfContractRequest {
    contractsIds?: string[] | undefined;
    hasDocument: boolean;
    optionalCommentary?: string | undefined;
    effectiveDate: Date;
    buyback?: TypeOfBuyback | undefined;
    toReturnMaterials?: string[] | undefined;
    reason?: string | undefined;
}

export interface ThirdAddress extends Address {
    sirenCode?: string | undefined;
    businessName?: string | undefined;
}

export interface ThirdPartyAddress {
    streetNb?: string | undefined;
    streetName?: string | undefined;
    additionalAdress?: string | undefined;
    zipCode?: number | undefined;
    city?: string | undefined;
}

export enum TypeOfBuyback {
    AllAssets = "AllAssets",
    OneOrManyAssets = "OneOrManyAssets",
}

export enum UploadFileType {
    RISK_CNI = "RISK_CNI",
    RISK_IDENT_MAT = "RISK_IDENT_MAT",
    RISK_KBIS = "RISK_KBIS",
    RISK_DMD_FINAN = "RISK_DMD_FINAN",
    RISK_ELEM_FINANCIER = "RISK_ELEM_FINANCIER",
    RISK_AUTRES = "RISK_AUTRES",
    SCLI_FICHE_SYNTHESE = "SCLI_FICHE_SYNTHESE",
    SCLI_ARRETS_MALADIES = "SCLI_ARRETS_MALADIES",
    SCLI_CERTIFICAT_INV = "SCLI_CERTIFICAT_INV",
    SCLI_CERTIFICAT_POSTM = "SCLI_CERTIFICAT_POSTM",
    SCLI_AVENANT = "SCLI_AVENANT",
    SCLI_RIB_CLT = "SCLI_RIB_CLT",
    SCLI_COURRIER_ENT = "SCLI_COURRIER_ENT",
    SCLI_LETTRE_DESIST = "SCLI_LETTRE_DESIST",
    SCLI_BON_COMMANDE = "SCLI_BON_COMMANDE",
    SCLI_KBIS = "SCLI_KBIS",
    SCLI_POURVOIRES = "SCLI_POURVOIRES",
    SCLI_STATUS = "SCLI_STATUS",
    SCLI_BON_POUR_ENLV = "SCLI_BON_POUR_ENLV",
    SCLI_DEP_PLAINTE = "SCLI_DEP_PLAINTE",
    SCLI_RAPP_SINISTRE = "SCLI_RAPP_SINISTRE",
    SCLI_ETAT_FIN = "SCLI_ETAT_FIN",
    SCLI_CESS_COMMERCE = "SCLI_CESS_COMMERCE",
    SCLI_CNI = "SCLI_CNI",
    SCLI_ATTEST_BE = "SCLI_ATTEST_BE",
}

export enum ValidityPeriod {
    ContractDuration = "ContractDuration",
    Annually = "Annually",
}

export interface FinancialTypeCounts {
    Leasing?: number;
    Rent?: number;
    Loan?: number;
    DedicatedLoan?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

export class Utilities
{
    public static async processResponse<T>(
        response: Response,
        isFile: boolean,
        dateFields: string[],
    ): Promise<T> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status >= 200 && status < 300) {
            if (isFile) {
                const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
                const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
                return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers } as unknown as T; });
            }
            if (response && response.text) {
                return response.text().then((_responseText) => {
                    try {
                        const result: any = _responseText === '' ? null : JSON.parse(_responseText, (key, value) => {
                            if (value
                                && dateFields?.includes(key)
                                && (typeof value === 'string' || (Array.isArray(value) && value.every(i => typeof i === 'string'))) 
                                ) {
                               if (Array.isArray(value)) {
                                    return value.map(v => Utilities.ConvertToDate(v));
                                }
                                else {
                                    return Utilities.ConvertToDate(value);
                                }
                            }
                            return value;
                        }) as T;
                        return result;
                    } catch (error) {
                        return Promise.reject(new SwaggerException(error instanceof Error ? error.message : 'JSON.parse error', status, _responseText, _headers, null));
                    }
                });
            }
            else {
                return Promise.resolve<T>(<any>null);
            }
        }

        const errorMessage = status < 500 ? 'A server error occurred.' : 'An unexpected server error occurred.';

        if (response instanceof Error) {
        	return Promise.reject(new SwaggerException(response.message, status, response.message, _headers, null));
        }

        if (response && response.text) {
        	const responseText = await response.text();
        	return Promise.reject(new SwaggerException(errorMessage, status, responseText, _headers, null));
        }

        return Promise.resolve<T>(<any>null);
    }

    public static ConvertToDate (value: any) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date;
    }
}